var amdi18n={"__root":{"initialization_started":"Initialization started","browser_not_supported":"Browser is not supported: <a href=\"https://www.skidentity.de/en/system/browser\" target=\"_blank\">Supported Browsers</a>","version":"Version ","invalid_context":"Invalid context: ","no_session_found":"No session parameter found: ","no_flow_id_found":"No flow-id parameter found: ","invalid_get_cloud_id_url":"GetCloudID URL is invalid: ","invalid_revoke_cloud_IDM_URL":"RevokeCloudIDs URL is invalid: ","invalid_transfer_cloud_id_url":"TransferCloudID URL is invalid: ","no_salt_found":"No salt found: ","initialization_succeeded":"Initialization succeeded","initialization_failed":"Initialization failed","started":"Starting Identity Manager","succeeded":"Identity Manager started","failed":"Identity Manager failed","context_change_started":"Context change started","context_change_succeeded":"Context change succeeded","context_change_failed":"Context change failed","abort":"Identity Manager aborting","activation_started":"Activation started","activation_succeeded":"Activation succeeded","activation_failed":"Activation failed","activation_failed_type_browser_xhr_unsupported_for_option":"Activation failed: BROWSER-XHR not supported for given AuthenticationOption","activation_failed_type_unknown":"Activation failed: Unknown activation type","cip_response_invalid_bad_status":"Received invalid Response from CloudID Producer: Bad Status: ","unknown_cip_command":"Unknown CIP command: "},"__de":{"browser_not_supported":"Browser wird nicht unterstützt: <a href=\"https://www.skidentity.de/system/browser\" target=\"_blank\">Unterstützte Browser</a>"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/service/nls/Core_strings.js
// module id = 299
// module chunks = 4